import React, { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { getContextValue } from './utils/globalContext';
import Main from './main';

const LoginPage = lazy(() => import('./pages/login'));
const LogoutConfirmationPage = lazy(
  () => import('./pages/logout-confirmation'),
);
const LogoutSuccessPage = lazy(() => import('./pages/logout-success'));
const LogoutProgressPage = lazy(() => import('./pages/logout-progress'));
const OtpRequiredPage = lazy(() => import('./pages/otp-required'));
const OtpErrorPage = lazy(() => import('./pages/otp-error'));
const ApprovalPage = lazy(() => import('./pages/approval'));
const TermsAndConditionsPage = lazy(
  () => import('./pages/terms-and-conditions'),
);
const ProgressiveProfilingPage = lazy(
  () => import('./pages/progressive-profiling'),
);
const ErrorPage = lazy(() => import('./pages/error'));

const pageIdToComponentMap = {
  login: <LoginPage />,
  'idp.slo.confirm': <LogoutConfirmationPage />,
  'idp.slo.success': <LogoutSuccessPage />,
  'idp.slo.progress': <LogoutProgressPage />,
  'otp.required': <OtpRequiredPage />,
  'otp.error': <OtpErrorPage />,
  'scopes.approval': <ApprovalPage />,
  'terms-and-conditions': <TermsAndConditionsPage />,
  'progressive-profiling': <ProgressiveProfilingPage />,
  error: <ErrorPage />,
};

const getPage = (pageId) => {
  return pageIdToComponentMap[pageId] || null;
};

const pageId = getContextValue('pageId');

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Main />,
    children: [
      {
        path: '*',
        element: getPage(pageId),
      },
    ],
  },
]);
